import React from 'react';
import Input from 'components/components/Input';
import { officeTypeOptions } from 'components/RequestServiceDrawer/utils/constants';
import QuantityField from '../../QuantityField';

type Props = {
  names?: { officeType: string, desks: string, quantity: string },
  officeType?: string,
  desks?: number,
  quantity?: number,
  precision?: number,
  onOfficeType?: (value: string) => void,
  onDesks?: (value: number | null) => void,
  onQuantity?: (value: number | null) => void,
};

const OfficeFields = ({
  names, officeType, desks, quantity, precision, onOfficeType, onDesks, onQuantity,
}: Props) => (
  <>
    <Input name={names?.officeType} label="Office type" className="overview-column" required layout="vertical" rules={[{ required: true, message: 'Choose an office type' }]}>
      <Input.Select options={officeTypeOptions} placeholder="Choose an office type" value={officeType || undefined} onChange={onOfficeType} />
    </Input>
    <QuantityField name={names?.desks} label="Number of desks" value={desks} onChange={onDesks} precision={precision} />
    <QuantityField name={names?.quantity} label="Number of months" value={quantity} onChange={onQuantity} precision={precision} />
  </>
);

OfficeFields.defaultProps = {
  names: undefined,
  precision: undefined,
  officeType: undefined,
  desks: undefined,
  quantity: undefined,
  onOfficeType: undefined,
  onDesks: undefined,
  onQuantity: undefined,
};

export default OfficeFields;
